$( document ).ready(function() {

  if (window.matchMedia("(max-width: 1023px)").matches) {
    if($('.product-single__media-slider').length){
      $('.product-single__media-slider').slick({
      infinite: false,
    	dots: true,
    	arrows: false,
      slidesToShow: 1.0
      });
    }
    // code for change slider image based on variant color change
    
    if($('.template-product').length){
  $('input[data-single-option-selector]').on('change', function() {   
    setTimeout(function(){
  var selected_variant_id = parseInt($('.product__form [name="id"]').val());
    const productJson1 = JSON.parse($("script[data-product-json]").text());
    function updateVariantImageById(variantId) {      
      const variant = productJson1.variants.find(v => v.id === variantId);
      console.log('variant ', variant);      
      if (variant && variant.featured_image) {
        var newslickImage = variant.featured_image.src;
           $('.product-single__media-slide').each(function() {
          const currentImageSrc = $(this).attr('data-image-url');
          
          if (currentImageSrc === newslickImage) {
              // console.log('yes this is fount ------------------------------+++++');
              let slickIndex = $(this).attr('data-slick-index');
              console.log(slickIndex)
              $('.product-single__media-slider').slick('slickGoTo', slickIndex);

          }
           })        
        // $("#variant-image").attr("src", variant.featured_image.src);
      }
    }      
    updateVariantImageById(selected_variant_id); 
  },300)
  })
}
    

  if($('.similar-product-mobile-layout .similar-product-wrapper').length){
    $('.similar-product-mobile-layout .similar-product-wrapper').slick({
        slidesToShow: 2.3,
        infinite: false,
        dots: false,
        arrows: false,
        responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4.5,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2.3,
          }
        }
        ]
    });
} 
}
if($('.view-product-image-gallery').length){
$('.view-product-image-gallery').slick({
    infinite: true,
	dots: true,
	arrows: false,
    slidesToShow: 1
});  
}
  if($('.similar-product-desktop-layout .similar-product-wrapper').length){
    $('.similar-product-desktop-layout .similar-product-wrapper').slick({
        slidesToShow: 2.3,
        infinite: false,
        dots: true,
        arrows: false,
        centerMode: false
    });
}  

  if($('.key-feature-wrapper').length){
    $('.key-feature-wrapper').slick({
        slidesToShow: 2.2,
        infinite: false,
        dots: true,
        arrows: false,
        centerMode: false
    });
}    
    

$('.similar-product-badge').click(function(){
    $('.similar-products-overlay').addClass('is-open');
    $('body').addClass('is-open');
    $('.similar-product-popup').addClass('is-open');
}) 
$('.close-similar-popup').click(function(){
    $('.similar-products-overlay').removeClass('is-open');
    $('body').removeClass('is-open');
    $('.similar-product-popup').removeClass('is-open');
})    



let addonn_height;
$('.metafields-products').each(function(){
var alldiv_height = 0;
 let get_metafield_product_count = $(this).find('.meta-products-view').length; 
  let getlength_of_viewmore = $(this).attr('data-custom-product-title');
//   console.log('aaa -- ',getlength_of_viewmore)
// console.log(get_metafield_product_count)
    if(get_metafield_product_count > getlength_of_viewmore){
        var counter = 0;
        $(this).find('.meta-products-view').each(function(ix,em){
        console.log('ix', ix)   
        alldiv_height = alldiv_height + $(this).outerHeight(); 
               counter++;
        if (counter >= getlength_of_viewmore) {
        return false; 
        }
        })  
        // console.log('eee ',alldiv_height)
        addonn_height = alldiv_height+50;
        $(this).find('.meta-products-load').height(addonn_height)
        $(this).css('overflow','hidden')
        $(this).find('.product-view-more-button').show();    
    }
})    


$(document).on('click','.product-view-more-button',function(){
    $(this).parents('.metafields-products').find('.meta-products-load').css('height','unset')
    $(this).html('View less');
  $(this).addClass('view-less-button');
   $(this).removeClass('product-view-more-button');
})

  $(document).on('click','.view-less-button',function(){
    $(this).parents('.metafields-products').find('.meta-products-load').height(addonn_height);
    $(this).html('View more');
  $(this).removeClass('view-less-button');
     $(this).addClass('product-view-more-button');
     $('html, body').animate({
        scrollTop: $(this).parents('.metafields-products').find('.meta-products-load').offset().top - 80
    },10);
})  

$(document).mouseup(function (e) {
    if ($(e.target).closest(".view-product-details-popup").length === 0) {
        $('.view-product-details-popup').removeClass('is-open');
        $('.remove-item-cart-overlay').removeClass('is-open');
    }
    if ($(e.target).closest(".similar-product-popup").length === 0) {
      $('.similar-product-popup').removeClass('is-open');
      $('.similar-products-overlay').removeClass('is-open');
      $('body').removeClass('is-open');
    }
});
$('.close-product-info-popup').click(function(){
  $('.view-product-details-popup').removeClass('is-open');
        $('.remove-item-cart-overlay').removeClass('is-open');
})  
  $('.view-product').click(function(){
    $(this).parents('.meta-products-view').find('.view-product-details-popup').addClass('is-open');
    $(this).parents('.meta-products-view').find('.remove-item-cart-overlay').addClass('is-open');
})

  var $addToCartBtn = $('.product__submit__add');
  var $stickyAddToCart = $('.sticky-add-to-cart');

  function toggleStickyAddToCart() {
    var scrollTop = $(window).scrollTop();
    var addToCartOffset = $addToCartBtn.offset().top + $addToCartBtn.outerHeight();

    if (scrollTop > addToCartOffset) {
      $('body').addClass('is-sticky')
    } else {
      $('body').removeClass('is-sticky')
    }
  }

if($('.template-product').length){  
  $(window).on('scroll', toggleStickyAddToCart);
  toggleStickyAddToCart(); 
}
  $('.sticky-add-to-cart').on('click', function() {
    $('html, body').animate({
      scrollTop: $('.product-single__details').offset().top
    }, 'slow');
  });
})  

// cart page js start here


$(document).on('click','.coupon-view-more-button',function(){  
  $('.ticket-coupon-section.hidden-discount-code').show();
  $(this).removeClass('coupon-view-more-button');
  $(this).addClass('coupon-view-less-button');
  $(this).html('View Less Coupons >')
})
$(document).on('click','.coupon-view-less-button',function(){
  $('.ticket-coupon-section.hidden-discount-code').hide();
  $(this).removeClass('coupon-view-less-button');
  $(this).addClass('coupon-view-more-button');
  $(this).html('View More Coupons >')
})

$(document).on('click','.item-view-all-button',function(){
    $(this).removeClass('item-view-all-button')
      $('.cart__items__wrapper').find('.cart__item').each(function(){
      $(this).css('display','flex');
  })
})

$(document).ready(function() {
  let remainig_swatch;
  let swatches = $('.siblings__swatch');
   if (window.matchMedia("(max-width: 1023px)").matches) {
      if (swatches.length > 3) {
        swatches.slice(3).hide(); // Hide elements after the first 2
           remainig_swatch = swatches.length - 3;
          $('.siblings').append(`<a class="siblings__swatch siblings__swatch--circle siblings__swatch--image sibling-remaining-items custom-sibling-remaining-items">+${remainig_swatch} more</a>`)
      }
   }else{
        if (swatches.length > 3) {
        swatches.slice(3).hide(); // Hide elements after the first 3
           remainig_swatch = swatches.length - 3;
          $('.siblings').append(`<a class="siblings__swatch siblings__swatch--circle siblings__swatch--image sibling-remaining-items custom-sibling-remaining-items">+${remainig_swatch} more</a>`)
      }
   }

$(document).on('click','.sibling-remaining-items',function(){
    $(this).html('Show less')
    $('.siblings__swatch').show(); 
     $(this).removeClass('sibling-remaining-items') 
    $(this).addClass('sibling-view-less-button');
})
$(document).on('click','.sibling-view-less-button',function(){
     if (window.matchMedia("(max-width: 1023px)").matches) {
      if (swatches.length > 3) {
        swatches.slice(3).hide(); // Hide elements after the first 2
        remainig_swatch = swatches.length - 3;
        $(this).html('+'+remainig_swatch+' more')
      }
    }else{
        if (swatches.length > 3) {
        swatches.slice(3).hide(); // Hide elements after the first 3
        remainig_swatch = swatches.length - 3;
          $(this).html('+'+remainig_swatch+' more')
    }
     }
    
    // $('.siblings__swatch').show(); 
     $(this).addClass('sibling-remaining-items') 
     $(this).removeClass('sibling-view-less-button');
})  

    $('.coupon-apply').click(function() {
        var textToCopy = $(this).attr('data-coupen-code');
        var $tempTextarea = $('<textarea>');
        $('body').append($tempTextarea);
        $tempTextarea.val(textToCopy).select();
        document.execCommand('copy');
        $tempTextarea.remove();
    });

  $('.scroll-to-featrued').on('click', function(e) {
  e.preventDefault();
  var target = $('#keyfeaturedcustomredirect');
  $('html, body').animate({
    scrollTop: $(target).offset().top - 70
  }, 100); 
});



var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};

waitForEl('.docapp-cart-with-coupon-summary--summary', function() {
  setInterval(function(){
    var p1 = $('.docapp-est-total .money').text();
    var p2 = $('.docapp-cart-subtotal .money').text()
    
    if (typeof p1 !== 'undefined' && p1 !== null && p1.trim() !== "" ){
      $('.rosada-sticky').html(p1)  
    }
    if (typeof p2 !== 'undefined' && p2 !== null && p2.trim() !== "" ){
    $('.line-through-off').html(p2)
    }
    
    var compare_Price = $('.docapp-cart-subtotal .money').attr('doubly-currency-inr')
    var regular_Price = $('.docapp-est-total .money').attr('doubly-currency-inr')
    if (typeof regular_Price !== 'undefined' && typeof compare_Price !== 'undefined' ){
      if(compare_Price > regular_Price){        
      var discountPercentage = ((compare_Price - regular_Price) / compare_Price) * 100;
      discountPercentage = Math.round(discountPercentage);    
        $('.stickiy-percentage-save').html(discountPercentage + "% OFF");
        $('.line-through-off').show();
        $('.stickiy-percentage-save').show();
      }else{
        $('.line-through-off').hide();
        $('.stickiy-percentage-save').hide();
      }
    }
    var dis_price = $('.docapp-cart-discount .money').text();
    if (typeof dis_price !== 'undefined' && dis_price !== null && dis_price.trim() !== "" ){
      if(compare_Price > regular_Price){
      $('.cart-shaving-amount span').html(dis_price)
      $('.cart-shaving-amount').show();
    }else{
      $('.cart-shaving-amount').hide();
    }
  }
},1000)
});

});

(function () {
  var atcSelector = '[data-add-to-cart], button[name="add"], .product__submit__add, .bundle-custom-product, .normaldefbtn';
  var propSelector = '[name^="properties["]';
  var mirrorAttribute = 'data-line-property-mirror';

  function ownerForm(field) {
    var id = field.getAttribute('form');
    if (!id) return null;
    var form = document.getElementById(id);
    return form && form.tagName === 'FORM' ? form : null;
  }

  function isSubmittable(field) {
    if (field.disabled) return false;
    if (field.type === 'checkbox' || field.type === 'radio') return field.checked;
    return String(field.value).trim() !== '';
  }

  function syncForm(form) {
    var stale = form.querySelectorAll('[' + mirrorAttribute + ']');
    for (var i = 0; i < stale.length; i++) {
      stale[i].parentNode.removeChild(stale[i]);
    }

    var fields = document.querySelectorAll(propSelector);
    for (var j = 0; j < fields.length; j++) {
      var field = fields[j];
      if (form.contains(field)) continue;
      if (ownerForm(field) !== form) continue;
      if (!isSubmittable(field)) continue;

      var mirror = document.createElement('input');
      mirror.type = 'hidden';
      mirror.name = field.name;
      mirror.value = field.value;
      mirror.setAttribute(mirrorAttribute, '');
      form.appendChild(mirror);
    }
  }

  function syncAllForms() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      syncForm(forms[i]);
    }
  }

  function syncFromField(event) {
    var field = event.target;
    if (!field || typeof field.matches !== 'function') return;
    if (!field.matches(propSelector)) return;
    var form = ownerForm(field);
    if (form) syncForm(form);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    if (!target.closest(atcSelector)) return;
    syncAllForms();
  }, true);

  document.addEventListener('input', syncFromField, true);
  document.addEventListener('change', syncFromField, true);
})();